import React from 'react';

import { SerializedStyles } from '@emotion/react/dist/emotion-react.cjs';
import { Box } from '@mui/material';
import { alpha, Theme } from '@mui/material/styles';

import PlayLargeIcon from '../../../../assets/icons/PlayLargeIcon';
import styled from '../../../../styled';
import { colorsPalette } from '../../../../theme';

interface CardPlayIconProps {
  wrapperCss?: SerializedStyles | (({ theme }: { theme: Theme }) => SerializedStyles);
  iconCss?: SerializedStyles | (({ theme }: { theme: Theme }) => SerializedStyles);
}

const CardPlayIcon: React.FC<CardPlayIconProps> = ({ wrapperCss, iconCss, ...rest }) => {
  return (
    <Wrapper optionalStyles {...rest}>
      <StyledPlayIcon iconCss={iconCss} color={colorsPalette.white} />
    </Wrapper>
  );
};

export default CardPlayIcon;

const Wrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'optionalStyles',
})`
  position: absolute;
  width: 80px;
  height: 80px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    border-radius: 50%;
    background: ${alpha(colorsPalette.blueDark, 0.5)};
  }
  ${({ optionalStyles }) => optionalStyles}
`;

const StyledPlayIcon = styled(PlayLargeIcon, {
  shouldForwardProp: (prop) => prop !== 'optionalStyles',
})`
  width: 21px;
  height: 24px;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: 33px;
    height: 37px;
    margin-left: 8px;
  }
  ${({ optionalStyles }) => optionalStyles}
`;
